import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useGetVehicleQuery, useOrderByIdQuery } from '../../../Store/Apis/bookingApi';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrintJobCard = () => {
    const user = useSelector((state) => state.auth.user)
    const [logoLoaded, setLogoLoaded] = useState(false); // Track logo loading state
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('id');

    const orderByIdApi = useOrderByIdQuery({
        keyID: orderId
    });
    const vehicleByOrderIdApi = useGetVehicleQuery({
        orderId: orderId
    }, {skip: !orderId});

    useEffect(() => {
        // Hide sidebar and header by adding CSS classes
        document.querySelector('aside.sidenav').style.display = 'none';
        document.querySelector('.sidenav.fixed-start + .main-content').style.marginLeft = '0';
        document.querySelector('.navbar-main').style.display = 'none';
    }, []);

    useEffect(() => {
        if (orderByIdApi.isSuccess && logoLoaded) {
            // Open print dialog on success
            window.print();

            // Close the page when the print dialog is closed
            const handleAfterPrint = () => {
                window.close();
            };

            window.addEventListener('afterprint', handleAfterPrint);

            return () => {
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [orderByIdApi.isSuccess, window, logoLoaded]);

    if (!orderByIdApi.isSuccess) {
        return null;
    }

    return (
        <div className='card' id="invoice">
            <div className="card-body">
                <div className="page-wrapper" style={{ padding: 36 }}>
                    <table className="table table-borderless">
                        <thead>
                            <tr>
                                <td colSpan="3">
                                    <img src={user?.logo} alt="" height={70} className='mb-2' onLoad={() => setLogoLoaded(true)} />
                                    <h4 className='mb-4'>{orderByIdApi.data.data[0].outletName}</h4>
                                    <h6 className="text-uppercase fw-600 mb-1">Customer</h6>
                                    <p className="mb-0">{orderByIdApi.data.data[0].customerName}</p>
                                    <p className="mb-0">{orderByIdApi.data.data[0].outletPhone}</p>
                                    <p className="mb-0">{orderByIdApi.data.data[0].outletAddress}</p>
                                </td>
                                <td colSpan="2" className="text-end">
                                    <h6 className="fw-bold">
                                        <span>JOB NO -</span>
                                        <span className="ms-2">{orderByIdApi.data.data[0].orderNumber.split('-').join("/")}</span>
                                    </h6>
                                    <p className="mb-1">
                                        <span>TECHNICIAN:</span>
                                        <span className="fw-600 ms-2">{orderByIdApi.data.data[0].technicianName}</span>
                                    </p>
                                    <p className="mb-1">
                                        <span>Order Date:</span>
                                        <span className="fw-600 ms-2">{new Date(orderByIdApi.data.data[0].orderDate).toLocaleDateString()}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" className="text-center">
                                    <h4 className="text-uppercase my-3">JOB CARD</h4>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="bg-light">
                                <th className="text-uppercase text-secondary text-sm text-dark px-3">#</th>
                                <th className="text-uppercase text-secondary text-sm text-dark">Date</th>
                                <th className="text-uppercase text-secondary text-sm text-dark">PARTICULARS</th>
                                <th className="text-uppercase text-secondary text-sm text-dark">QTY</th>
                                <th className="text-uppercase text-secondary text-sm text-dark">Remarks</th>
                            </tr>
                            {orderByIdApi.data.data[0].serviceTypeAndName.map((service, index) => (
                                <tr key={service.serviceID}>
                                    <td className="px-3">{index + 1}</td>
                                    <td>{new Date(orderByIdApi.data.data[0].orderDate).toLocaleDateString()}</td>
                                    <td>
                                        <div className="d-flex flex-column">
                                            <h6 className="mb-0">{service.serviceName}</h6>
                                            <p className="mb-0 text-sm">{service.productServiceName}</p>
                                            <p className="mb-0 text-sm">{service.serviceName}</p>
                                        </div>
                                    </td>
                                    <td>{service.quantity}</td>
                                    <td>{service.notes}</td>
                                </tr>
                            ))}
                            <td colSpan={5}>
                                <div className="p-4">
                                    <h4 className='text-center'>VEHICLE INFORMATION</h4>
                                    <table className='table table-bordered'>
                                        <tr>
                                            <td className='text-dark bg-light px-3 py-2' style={{maxWidth: '40%'}}>REGISTRATION NUMBER</td>
                                            <td style={{width: '60%'}} className='px-3'>{vehicleByOrderIdApi?.data?.data[0]?.regNumber}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-dark bg-light px-3 py-2' style={{width: '40%'}}>VIN NUMBER</td>
                                            <td style={{width: '60%'}} className='px-3'>{vehicleByOrderIdApi?.data?.data[0]?.vinNumber}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-dark bg-light px-3 py-2' style={{width: '40%'}}>KILOMETER READING</td>
                                            <td style={{width: '60%'}} className='px-3'>{vehicleByOrderIdApi?.data?.data[0]?.kmRead}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-dark bg-light px-3 py-2' style={{width: '40%'}}>FUEL READING</td>
                                            <td style={{width: '60%'}} className='px-3'>{vehicleByOrderIdApi?.data?.data[0]?.fuelRead}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-dark bg-light px-3 py-2' style={{width: '40%'}}>CAR TOOLS & SPARE WHEELS</td>
                                            <td style={{width: '60%'}} className='px-3'>{vehicleByOrderIdApi?.data?.data[0]?.toolsSpare}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-dark bg-light px-3 py-2' style={{width: '40%'}}>SCRATCHES & DENTS</td>
                                            <td style={{width: '60%'}} className='px-3'>{vehicleByOrderIdApi?.data?.data[0]?.scratchesDents}</td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                            <tr>
                                <td colSpan="3" className='pt-4'>
                                    <h6 className="text-uppercase fw-500 mb-2">{orderByIdApi.data.data[0].outletName}</h6>
                                    <p className="mb-0 text-sm">{orderByIdApi.data.data[0].outletPhone}</p>
                                    <p className="mb-0 text-sm">{orderByIdApi.data.data[0].outletAddress}</p>
                                </td>
                                <td colSpan="2" className="align-top pt-4">
                                    <div className="d-flex justify-content-between">
                                        <span className='fw-600'>Authorisation:</span> 
                                    </div>
                                    <div className='mb-4'>
                                        <div className="d-flex justify-content-between">
                                            <span>Manager Signature:</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span>Date:</span>
                                        </div>
                                    </div>
                                    <div className='mb-4'>
                                        <div className="d-flex justify-content-between">
                                            <span>Technician Signature:</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span>Date:</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="4">
                                    <hr className="bg-secondary" />
                                    <h6 className="fw-500">Notes:</h6>
                                    <p>
                                        {orderByIdApi?.data?.data[0].notes}
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default PrintJobCard;
